import { Button } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { AppTable } from "components/molecules";
import { TableHelper } from "helpers";
import { usePaginationRequest } from "hooks/useRequest";
import { IGetZoneLineRequest, IZoneLine } from "model";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import ZoneApiService from "services/ZoneApiService";
import { FIRST_PAGE } from "utils/Const";
import { I18nTranslator, translations } from "utils/i18n";

const LineOrder = () => {
  const params = useParams<{
    id: string;
    code: string;
  }>();

  const [request, setRequest] = useState<IGetZoneLineRequest>({
    zoneCode: params.code,
    pageNumber: FIRST_PAGE,
    pageSize: 100,
    orderBy: "lineCode",
  });

  const { loading, result } = usePaginationRequest<
    IGetZoneLineRequest,
    IZoneLine[]
  >(request, ZoneApiService.getAllZoneLines);

  const handleChangePage = (pageNumber: number) => {
    setRequest({ ...request, pageNumber: pageNumber });
  };
  const _handlePageSizeChange = (pageSize: number) => {
    setRequest({ ...request, pageSize: pageSize });
  };
  const _handleSearchChange = (searchText: string) => {
    setRequest({ ...request, searchText: searchText });
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "lineCode",
      headerName: I18nTranslator(translations.masterData.lineCode),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "lineName",
      headerName: I18nTranslator(translations.masterData.lineName),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "type",
      headerName: I18nTranslator(translations.masterData.type),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "length",
      headerName: I18nTranslator(translations.masterData.length),
      size: 80,
      align: "right",
    }),
    TableHelper.createCell({
      field: "level",
      headerName: I18nTranslator(translations.masterData.level),
      size: 80,
      align: "right",
    }),
    TableHelper.createCell({
      field: "order",
      headerName: I18nTranslator(translations.masterData.order),
      size: 80,
      align: "right",
    }),
    TableHelper.renderActivationCell(),
    TableHelper.createCell({
      field: "description",
      headerName: I18nTranslator(translations.masterData.description),
      size: "medium",
      align: "left",
    }),
  ];
  return (
    <AppTable<IZoneLine>
      loading={loading}
      data={result}
      columns={COLUMNS}
      onChangePage={handleChangePage}
      onSearch={_handleSearchChange}
      hideHeader
      searchPlaceholder="Tìm kiếm: Tên dãy"
      actionColumnProps={{ hideEdit: true, hideImport: true }}
      // defaultHeaderTable={260}
      onPageSizeChange={_handlePageSizeChange}
    />
  );
};

export default LineOrder;
